import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGButtons } from './voyageUiGButtons-sidecar'
import { voyageUiLoadShip } from './voyageUiLoadShip-sidecar'

export interface IVoyageUiEditor extends IVoyageUiCanvas {}

let _obj: IVoyageUiEditor | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
  }
  return _obj
}
const create = () => {
  let tw = 0
  let th = 0
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IVoyageUiCanvas = voyageUiCanvas.assign<IVoyageUiEditor>(canvas, {})

  let gb = voyageCamera.getGameBounds()
  let x = gb.width - 500
  let y = 20 + 40
  let b = voyageUiGButtons.create('New', x, y, () => {
    let name = (prompt('Name') || '').trim()
    if (name) {
      //goatGameMode_freeBuild.setFilename(name)
    }
  })
  obj.buttons.push(b)
  x += 120
  b = voyageUiGButtons.create('Load', x, y, () => {
    voyageUiLoadShip.setOpen(true)
  })
  obj.buttons.push(b)
  x += 120

  return obj
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  voyageUiCanvas.setOpen(obj, isOpen)
}

export const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let gb = voyageCamera.getGameBounds()

  let x = gb.width - 500
  let y = 20

  let w = 500
  let h = 300
  let sy = y
  let sx = x

  let addText = (text: string, ox: number = 0, oy: number = 0) => {
    let t = voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3)
    stevieTexts2.setWrapWidth(t, w - 60)
    y += 20
    return t
  }

  let addSpacer = () => {
    y += 30
  }

  addText('Editor - ' + voyageSaver.getLastFilename())
  // addText('Add new / load button')

  voyageUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()
  if (obj.isOpen) {
    voyageUiCanvas.update(obj)
    render()
  }
}
